/* eslint-disable no-undef */
if (H) {
    if (!H.geo.LineString) {
        H.geo.LineString = H.geo.Strip;
    }
}
